    <mat-sidenav-container class="sidenav-container">
        <mat-sidenav mode="side" opened fixedInViewport="true" fixedTopGap="0" fixedBottomGap="0" class="sidenav" [style.width.px]="isExpanded ? 250 : 90">
            <!-- Your sidenav content goes here (e.g., navigation links) -->
            <div class="flex justify-content-between pt-4 pb-4 pr-2 pl-3">
                <img *ngIf="!isExpanded" src="\XpressApp\assets\images\partner\Xpress.svg" />
                <img *ngIf="isExpanded" src="\XpressApp\assets\images\partner\Vector.svg" />
                <div class="toggle-button cursor-pointer text-right" (click)="toggleSidebar()">
                    <mat-icon>{{!isExpanded ? 'chevron_right' : 'chevron_left'}}</mat-icon>
                </div>
            </div>
            <mat-divider></mat-divider>
            <mat-nav-list>
                <div class="flex flex-column align-items-center">
                    @for (menuItem of menuItems; track menuItem; let i = $index) {
                        <mat-list-item [activated]="activeLink === menuItem.activeMenu" (click)="subClick(menuItem, $event)"
                            [attr.data-testid]="navigationMenuTestId(menuItem)">
                            <div class="flex align-items-center" [ngClass]="isExpanded ? 'flex-row' : 'flex-column'">
                                <button disabled mat-icon-button color="primary" [ngClass]="{'menu-btn': !isExpanded}">
                                    <mat-icon>{{menuItem.icon}}</mat-icon>
                                </button>
                                <mat-label>{{menuItem.label}}</mat-label>
                            </div>
                        </mat-list-item>
                    }
                    <mat-menu #menu="matMenu">
                        <button mat-menu-item>Operations</button>
                        <button mat-menu-item>Products</button>
                    </mat-menu>
                </div>
            </mat-nav-list>
            <mat-divider *ngIf="isExpanded"></mat-divider>
            <div class="flex flex-column" [ngClass]="{'align-items-center' : !isExpanded}">
                <div [ngClass]="isExpanded ? 'flex align-items-center flex-row pt-4 custom-pr pr-2 justify-content-between' : ''">
                    <div [ngClass]="isExpanded ? 'flex flex-row' : 'flex align-items-center flex-column'">
                        <div *ngIf="!_profile.ImageUrl" class="mt-1 xpress-topbar-avatar-empty" [ngClass]="{'mr-3' : isExpanded}">
                            {{_profile.FirstName | slice:0:1 | uppercase}}{{_profile.LastName | slice:0:1 | uppercase}}
                        </div>
                        <div *ngIf="_profile.ImageUrl" [ngClass]="{'mr-2' : isExpanded}">
                            <img class="mt-1 xpress-topbar-avatar" src="{{_profile.ImageUrl}}" width="48" height="48" />
                        </div>
                        <div class="flex flex-column text-sm dark-blue">
                            <mat-label>{{isExpanded ? _profile.FirstName + ' ' + _profile.LastName : 'Account'}}</mat-label>
                            <mat-label class="email-test" *ngIf="isExpanded">{{_profile.Email}}</mat-label>
                        </div>
                    </div>
                    
                    <div *ngIf="isExpanded" class="toggle-button cursor-pointer dark-blue text-right" (click)="logout()">
                        <mat-icon>logout</mat-icon>
                    </div>
                </div>
            </div>
        </mat-sidenav>
    </mat-sidenav-container>
    <mat-menu #menu="matMenu" xPosition="after" yPosition="below" [hasBackdrop]="true">
        @for (sub of subMenuItem; track sub){
            <button mat-menu-item (click)="subClick(sub, $event)" [attr.data-testid]="navigationMenuTestId(sub)">{{sub.label}}</button>
        }
    </mat-menu>
